export default __webpack_public_path__ + "static/media/design-9.0a60f53d.png";